import { useState, useEffect } from 'react'

export interface BackToTopProps {}

export const useBackToTop = (props: BackToTopProps) => {
  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        setIsActive(false)
      } else {
        setIsActive(true)
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return {
    ...props,
    isActive,
  }
}
